/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Berechne Routen in ${i.count} s`
};

const en_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Your route in ${i.count} s`
};

const es_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Tu itinerario en ${i.count} s`
};

const fr_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Votre itinéraire dans ${i.count} s`
};

const it_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Il tuo percorso in ${i.count} s`
};

const nl_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Jouw route in ${i.count} s`
};

const pt_itinerary__ad__loading = /** @type {(inputs: { count: NonNullable<unknown> }) => string} */ (i) => {
	return `Seu trajeto em ${i.count} s`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ count: NonNullable<unknown> }} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.itinerary__ad__loading(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("itinerary__ad__loading", locale)
	if (locale === "de") return de_itinerary__ad__loading(inputs)
	if (locale === "en") return en_itinerary__ad__loading(inputs)
	if (locale === "es") return es_itinerary__ad__loading(inputs)
	if (locale === "fr") return fr_itinerary__ad__loading(inputs)
	if (locale === "it") return it_itinerary__ad__loading(inputs)
	if (locale === "nl") return nl_itinerary__ad__loading(inputs)
	return pt_itinerary__ad__loading(inputs)
};